export default {
  checked: ['全选', 'Checked'],
  move: ['移动分类', 'Move Type'],
  deleteItem: ['删除元素', 'Delete Item'],
  all: ['全部元素', 'All'],
  typePlaceholder: ['请选择所属分类', 'Please select type'],
  unknownType: ['未分类', 'Unknown Type'],
  editType: ['编辑分类', 'Edit Type'],
  typeName: ['分类名称', 'Type Name'],
  typeNamePlaceholder: ['请输入新增分类名称', 'Please enter the new type name'],
  typeSortTip: [
    '您可以使用拖拽进行分类排序，同样支持 “右键” 执行快捷排序',
    'You can use drag and drop to sort, and also support "right click" to perform quick sort'
  ],
  typeCount: ['“$0” 包含 $1 个元素', 'The $0 contains $1 elements'],
  search: ['请输入元素名称', 'Please enter element name'],
  uploadTip: [
    '上传元素将归属当前分类，每个上传文件大小限制在100MB',
    'Uploaded elements will belong to the current category, and the size of each uploaded file is limited to 100MB'
  ],
  copied: ['已复制', 'Copied'],
  confirm: ['请求确认', 'Confirm'],
  rename: ['重命名', 'Rename'],
  renameLabel: ['您将重命名 <b>$0</b> 此元素，您完全确定吗？', 'You will rename this element <b>$0</b>, are you absolutely sure?'],
  namePlaceholder: ['请填写新的元素名称', 'Please enter element name'],
  nameRequire: ['当前元素名称不能为空', 'Current element name cannot be empty'],
  moveLabel: ['您将移动以下 <b>$0</b> 个元素至', 'You will move the following <b>$0</b> elements to'],
  movePlaceholder: ['请选择移动分类名称', 'Please select type name to move'],
  deleteLabel: ['您确定删除以下 <b>$0</b> 个元素吗?', 'Are you sure you want to delete the following <b>$0</b> elements?']
};
